import axios from 'axios';

import {
  getHeaders,
} from './Utils';

import {
  ENDPOINT_USER_PROFILE,
  ENDPOINT_USER_REGISTER,
  ENDPOINT_USER_SESSION,
  ENDPOINT_USER_LOGOUT,
  ENDPOINT_USER,
  API_HOST,
} from './constants';

export default class User {
  static loginByEmail(email, password) {
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: ENDPOINT_USER_SESSION,
      data: {
        email,
        password,
      },
    }).then((response) => {
      window.localStorage.setItem('accessToken', response.data.id);
      window.localStorage.setItem('session_ttl', response.data.ttl);
      window.localStorage.setItem('session_created', response.data.created);
      window.localStorage.setItem('user_id', response.data.userId);
      return Promise.resolve(response);
    });
  }

  static isLoggedIn() {
    const userId = window.localStorage.getItem('user_id');
    if(!userId) return false;

    return axios({
      method: 'get',
      headers: getHeaders(),
      url: `${ENDPOINT_USER}/${userId}`,
    }).then(() => Promise.resolve(true)).catch(() => Promise.resolve(false));
  }

  static login(username, password) {
    if (username && password) {
      return axios({
        method: 'post',
        headers: getHeaders(),
        url: ENDPOINT_USER_SESSION,
        data: {
          email: username,
          password,
        },
      }).then((response) => {
        window.localStorage.setItem('accessToken', response.data.id);
        window.localStorage.setItem('session_ttl', response.data.ttl);
        window.localStorage.setItem('session_created', response.data.created);
        window.localStorage.setItem('user_id', response.data.userId);
        return Promise.resolve(response);
      });
    }

    return false;
  }

  static oAuthLogin(service) {
    return `${API_HOST.replace('.io/api','.io').replace('3000/api', '3000')}/auth/${service}`;
  }

  static async loginWithOauth(query) {
    window.localStorage.setItem('accessToken', query.token);
    window.localStorage.setItem('session_ttl', 0);
    window.localStorage.setItem('session_created', 0);
    window.localStorage.setItem('user_id', query.userId);
  }

  static logout() {
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: ENDPOINT_USER_LOGOUT,
    }).then(() => {
      window.localStorage.removeItem('accessToken');
      window.localStorage.removeItem('session_ttl');
      window.localStorage.removeItem('session_created');
      window.localStorage.removeItem('user_id');
      return Promise.resolve(true);
    });
  }

  static register(email, firstName, lastName, password) {
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: ENDPOINT_USER_REGISTER,
      data: {
        realm: 'audory-editor',
        firstName: firstName,
        lastName: lastName,
        emailVerified: false,
        email,
        password,
      },
    });
  }

  static getProfile() {
    const userId = window.localStorage.getItem('user_id');
    if(!userId) return null;
    
    const filter = JSON.stringify({
      where: {
        ownerId: userId,
      },
    });

    return axios({
      method: 'get',
      headers: getHeaders(),
      url: `${ENDPOINT_USER_PROFILE}?filter=${filter}`,
    });
  }
  static setProfile(obj) {
    const userId = window.localStorage.getItem('user_id');
    if(!userId) return null;
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: `${ENDPOINT_USER_PROFILE}`,
      data: Object.assign(obj, {ownerId: userId}),
    });
  }

  static getAccount() {
    const userId = window.localStorage.getItem('user_id');
    if(!userId) return null;
    
    return axios({
      method: 'get',
      headers: getHeaders(),
      url: `${ENDPOINT_USER}/${userId}`,
    });
  }

  static verifyAccount() {
    const userId = window.localStorage.getItem('user_id');
    if(!userId) return null;
    
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: `${ENDPOINT_USER}/${userId}/verifyEmail`,
    });
  }

  static changeEmail(email) {
    const userId = window.localStorage.getItem('user_id');
    if(!userId) return null;
    
    return axios({
      method: 'patch',
      headers: getHeaders(),
      url: `${ENDPOINT_USER}/${userId}`,
      data: {
        email: email,
        emailVerified: false,
      },
    });
  }

  static changePassword(oldPass, newPass) {
    const userId = window.localStorage.getItem('user_id');
    if(!userId) return null;
    
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: `${ENDPOINT_USER}/change-password`,
      data: {
        oldPassword: oldPass,
        newPassword: newPass,
      },
    });
  }

  static resetPasswordRequest(email) {
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: `${ENDPOINT_USER}/resetPasswordRequest`,
      data: {
        email: email,
      },
    });
  }

  static resetPassword(newPass, accessToken) {
    return axios({
      method: 'post',
      headers: {'Authorization': accessToken},
      url: `${ENDPOINT_USER}/reset-password`,
      data: {
        newPassword: newPass,
      },
    });
  }

  static getIdByEmail(email) {
    const userId = window.localStorage.getItem('user_id');
    if(!userId) return null;
    
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: `${ENDPOINT_USER}/getIdByEmail`,
      data: {
        email: email,
      },
    });
  }

  static getEmailById(id) {
    const userId = window.localStorage.getItem('user_id');
    if(!userId) return null;
    
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: `${ENDPOINT_USER}/getEmailById`,
      data: {
        id: id,
      },
    });
  }

  static getName(userId = null) {
    if(!userId) userId = window.localStorage.getItem('user_id');
    if(!userId) return null;
    
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: `${ENDPOINT_USER}/getNameById`,
      data: {
        id: userId,
      },
    });
  }

  static setName(firstName, lastName) {
    const userId = window.localStorage.getItem('user_id');
    if(!userId) return null;
    
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: `${ENDPOINT_USER}/setName`,
      data: {
        firstName: firstName,
        lastName: lastName,
      },
    });
  }
  
}



// WEBPACK FOOTER //
// ./src/api/User.js